import React, { useEffect, useState, useRef } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import { NavLink, useLocation, useHistory } from "react-router-dom";
import { Menu, Tooltip, Dropdown } from 'antd';
import HeaderUser from '../components/HeaderUser/HeaderUser';
import MerchantSelector from '../components/MerchantSelector/MerchantSelector';
import { ReactComponent as HomeIconSVG } from '../img/navigation/home-new.svg';
import { ReactComponent as PaymentsIconSVG } from '../img/navigation/payments.svg';
import { ReactComponent as MerchantsIconSVG } from '../img/navigation/merchants-new.svg';
import { ReactComponent as WalletsIconSVG } from '../img/navigation/wallet-new.svg';
import { ReactComponent as CheckoutsIconSVG } from '../img/navigation/checkoutsIcon-new.svg';
import { ReactComponent as RecurringIconSVG } from '../img/navigation/recurring.svg';
import { ReactComponent as WithdrawIconSVG } from '../img/navigation/withdraw-new.svg';
import { ReactComponent as SettingsIconSVG } from '../img/navigation/settings-new.svg';
import { ReactComponent as ProfileIconSVG } from '../img/default-svg/profileCircle.svg';
import { ReactComponent as NftIconSVG } from '../img/navigation/nft-new.svg';
import { ReactComponent as CpayCardSVG } from '../img/navigation/cpayCard.svg';
import { ReactComponent as SwapSVG } from '../img/navigation/swap-new.svg';
import { ReactComponent as TransactionHistorySVG } from '../img/navigation/transactionHistory.svg';
import { ReactComponent as RepeatGuideSVG } from '../img/navigation/cpayTourSidebar.svg';
import { ReactComponent as DocumentaionSVG } from '../img/nfgpay-svg/documentation.svg';
import { ReactComponent as DocumentaionSVGFinvaro } from '../img/finvaro/documentation.svg';
import { ReactComponent as DocumentaionSVGClarnium } from '../img/clarnium/documentation.svg';
import { ReactComponent as SupportSVG } from '../img/nfgpay-svg/help-circle.svg';
import { useTranslation } from 'react-i18next';
import useWindowSize from '../utils/resizeHook';
import './Sider.scss';
import { AppConfig } from '../config';
import { identity } from '../utils/getIdentity';
import { useNftSupport } from '../utils/nftSupportContext';
import { getMerchantData } from "../redux/actions/merchantData";

function Sider({ siderState, userRole, setShowAppTour, userData, getMerchantData, merchantId, merchantData }) {
  const { currentWidth } = useWindowSize();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const { showNftSupportBlock } = useNftSupport();
  const [walletVersion, setWalletVersion] = useState(undefined);
  const initializedForMerchant = useRef(null);
  const walletVersionRef = useRef(walletVersion);
  walletVersionRef.current = walletVersion;
  const path = location.pathname;
  const pathRef = useRef(path);
  pathRef.current = path;
  
  useEffect(() => {
    const handleWalletVersionChange = () => {
      const wv = localStorage.getItem('walletVersion');
      if (wv && wv !== walletVersionRef.current) {
        setWalletVersion(wv);
        if (wv === 'v1') {
          switch (pathRef.current) {
            case '/wallets-new': history.push('/wallets'); break;
            case '/clients-new': history.push('/clients'); break;
          }
        } else {
          switch (pathRef.current) {
            case '/wallets': history.push('/wallets-new'); break;
            case '/clients': history.push('/clients-new');
          }
        }
      }
    };
    window.addEventListener('walletVersionChange', handleWalletVersionChange);
    return () => window.removeEventListener('walletVersionChange', handleWalletVersionChange);
  }, []);

  useEffect(() => {
    if (merchantId) {
      getMerchantData(merchantId);
    }
  }, [merchantId]);
  
  useEffect(() => {
    if (merchantData?.settingWallet?.version) {
      const version = merchantData.settingWallet.version;
      if (initializedForMerchant.current !== merchantId) {
        const wv = localStorage.getItem('walletVersion');
        if (wv) {
          setWalletVersion(wv);
        } else {
          setWalletVersion(version);
        }
        initializedForMerchant.current = merchantId;
      }
    }
  }, [merchantData]);

  const linkForDocs = {
    cpay: AppConfig?.hideLogo ? 'support@payblock.tech' : 'gemewallet@gmail.com',
    nfg: 'support@crypto-now.io',
    finvaro: 'support@finvaro.com',
    clarnium: 'dev@clarnium.io',
    inex: 'tics@inexlatam.com',
    insta: 'Operations@instaxchange.com',
    coinera: 'support@finera.com'
  };

  const language = localStorage.getItem('cpayAppLang');

  const walletsMenu = (
    <Menu>
      <Menu.Item>
        <NavLink exact to={`/wallets`}>
          {t('merchants.merchantWallets')}
        </NavLink>
      </Menu.Item>
      <Menu.Item>
        <NavLink exact to={`/clients`}>
          {t('merchants.clientWallets')}
        </NavLink>
      </Menu.Item>
    </Menu>
  );

  const Links = [
    {
      path: '/',
      text: t('home'),
      svg: <HomeIconSVG />,
      className: 'side-bar__home',
      id: 0,
    },
    {
      path: '/wallets',
      text: t('wallets.wallets'),
      svg: <WalletsIconSVG />,
      className: 'side-bar__wallets',
      id: 2,
      overlay: walletsMenu,
    },
    {
      path: '/checkouts',
      text: t('checkouts.checkouts'),
      svg: <CheckoutsIconSVG />,
      className: 'side-bar__checkouts',
      id: 3,
    },
    {
      path: '/withdraw',
      text: t('withdraw.withdraw'),
      svg: <WithdrawIconSVG />,
      className: 'side-bar__withdraw',
      id: 4,
    },
    {
      path: '/nft-wallet',
      text: t('nftWallet'),
      svg: <NftIconSVG />,
      className: 'side-bar__nft',
      id: 5,
      isVisible: true,
    },
    {
      path: '/swap',
      text: t('sideBar.swap'),
      svg: <SwapSVG />,
      className: 'side-bar__swap',
      id: 7,
    },
    {
      path: '/transactions',
      text: t('sideBar.transactionHistory'),
      svg: <TransactionHistorySVG />,
      className: 'side-bar__transaction',
      id: 8,
    },
    {
      path: '/settings',
      text: t('settings'),
      svg: <SettingsIconSVG />,
      className: 'side-bar__settings',
      id: 9,
    },
  ];

  const newLinks = [
    {
      path: '/',
      text: t('home'),
      svg: <HomeIconSVG />,
      className: 'side-bar__home side-bar__general',
      id: 0,
      isVisible: true,
      items: []
    },
    {
      path: '#',
      text: t('text.payments'),
      svg: <PaymentsIconSVG />,
      className: 'side-bar__general side-bar__wrapper',
      id: 2,
      isVisible: true,
      items: [
        {
          path: '/checkouts',
          text: t('checkouts.checkouts'),
          className: 'side-bar__checkouts',
          id: 3,
          isVisible: true,
        },
        {
          path: '/recurring-billing',
          text: t('checkouts.recurring'),
          className: 'side-bar__checkouts',
          id: 4,
          isVisible: identity !== 'clarnium',
        },
        {
          path: '/multisend',
          text: t('text.multisend'),
          className: 'side-bar__multisend',
          id: 5,
          isVisible: true,
        }
      ]
    },
    {
      path: '#',
      text: t('wallets.wallets'),
      svg: <WalletsIconSVG />,
      className: 'side-bar__general side-bar__wrapper',
      id: 6,
      isVisible: process.env.REACT_APP_IS_AVAILABLE_NEW_WALLET === 'true' && (walletVersion === 'v2' || merchantData?.settingWallet?.version === 'v1'),
      items: [
        {
          path: '/wallets-new',
          text: t('merchants.merchantWallets'),
          className: 'side-bar__wallets',
          id: 7,
          isVisible: true,
        },
        {
          path: '/clients-new',
          text: t('merchants.clientWallets'),
          className: 'side-bar__wallets',
          id: 8,
          isVisible: true,
        },
      ]
    },
    {
      path: '#',
      text: t('wallets.wallets'),
      svg: <WalletsIconSVG />,
      className: 'side-bar__general side-bar__wrapper',
      id: 6,
      isVisible: process.env.REACT_APP_IS_AVAILABLE_NEW_WALLET === 'true' ? walletVersion === 'v1' : true,
      items: [
        {
          path: '/wallets',
          text: t('merchants.merchantWallets'),
          className: 'side-bar__wallets',
          id: 7,
          isVisible: true,
        },
        {
          path: '/clients',
          text: t('merchants.clientWallets'),
          className: 'side-bar__wallets',
          id: 8,
          isVisible: true,
        },
        /*{
          path: '/nft-wallet',
          text: 'NFTs',
          className: 'side-bar__nft',
          id: 11,
          isVisible: true,
        },*/
      ]
    },
    {
      path: '#',
      text: t('text.transactions'),
      svg: <TransactionHistorySVG />,
      className: 'side-bar__transaction side-bar__general side-bar__wrapper',
      id: 12,
      isVisible: true,
      items: [
        {
          path: '/transactions',
          text: t('text.history'),
          className: 'side-bar__swap',
          id: 9,
          isVisible: true,
        },
        {
          path: '/swap',
          text: t('sideBar.swap'),
          className: 'side-bar__swap',
          id: 9,
          isVisible: true,
        },
        {
          path: '/withdraw',
          text: t('withdraw.withdraw'),
          className: 'side-bar__withdraw',
          id: 10,
          isVisible: true,
        },
        {
          path: '/address-book',
          text: t('addressBook.address_book'),
          className: 'side-bar__withdraw',
          id: 11,
          isVisible: true,
        },
      ]
    },
    {
      path: '/settings',
      text: t('settings'),
      svg: <SettingsIconSVG />,
      className: 'side-bar__settings side-bar__general',
      id: 13,
      isVisible: true,
    },
  ]

  if (userRole?.includes('corporate') && !newLinks.find(link => link.path === '/merchants')) {
    newLinks.splice(1, 0, {
      path: '/merchants',
      text: t('text.merchants'),
      svg: <MerchantsIconSVG />,
      className: 'side-bar__merchants side-bar__general',
      id: 1,
      isVisible: true,
      items: [],
    });
  }

  if (userRole?.includes('corporate') && !Links.find(link => link.path === '/merchants')) {
    Links.splice(1, 0, {
      path: '/merchants',
      text: t('merchants.merchants'),
      svg: <MerchantsIconSVG />,
      className: 'side-bar__merchants',
      id: 1,
      items: []
    });
  }

  Links.splice(6, 0, {
    path: '/recurring-billing',
    text: t('checkouts.recurring'),
    svg: <RecurringIconSVG />,
    className: 'side-bar__checkouts',
    id: 6,
  })

  if (currentWidth < 1024) {
    if (!Links.find(link => link.path === '/profile')) {
      Links.unshift({
        path: '/profile',
        text: t('profile.profile'),
        svg: <ProfileIconSVG />,
        className: 'side-bar__profile',
        id: 10,
      });
    }
  }

  if (currentWidth < 1024) {
    if (!newLinks.find(link => link.path === '/profile')) {
      newLinks.unshift({
        path: '/profile',
        text: t('profile.profile'),
        svg: <ProfileIconSVG />,
        className: 'side-bar__profile',
        id: 10,
        isVisible: true,
        items: [],
      });
    }
  }
  // remove My nft if nftSupport disabled
  const indexToRemove1 = Links.findIndex(link => link.isVisible === false);

  if (indexToRemove1 !== -1) {
    Links.splice(indexToRemove1, 1);
  }

  return (
    <div className={cn(`side-bar ${language === 'es' && 'side-bar-wider'} side-bar-${identity}`, { 'side-bar__closed': !siderState })}>
      <div>
        <div className="side-bar__block">
          {newLinks.map((link, linkIndex) => (
            link?.isVisible && <div className="side-bar__nav-link" key={`${link.path}-${linkIndex}-${link?.items?.[0]?.path || 'root'}`}>
              <NavLink
                exact={link?.path !== "/swap"}
                className={`side-bar__link side-bar__link-${identity}  ${link?.className}`}
                activeClassName={`${link?.items?.length > 0 && 'side-bar__link_active side-bar__link_active-${identity}'}`}
                to={link?.path}
              >
                {link?.svg}
                <span>{link?.text}</span>
                {link?.id === 6 && link?.items?.[0]?.path === '/wallets-new' && (
                  <span className="side-bar__badge">{t('admin.unified')}</span>
                )}
              </NavLink>

              {link?.items?.length ? link?.items?.map((item, itemIndex) => (
                item?.isVisible && (
                  <div key={`${item.path}-${itemIndex}`}>
                    <NavLink
                      exact={item?.path !== "/swap"}
                      className={`side-bar__link side-bar__link--inside side-bar__link-${identity}  ${item?.className}`}
                      activeClassName={`side-bar__link_active side-bar__link_active-${identity}`}
                      to={item?.path}
                    >
                      <span>{item?.text}</span>
                    </NavLink>
                  </div>
                )
              )) : null}
            </div>
          ))}

          {/*{AppConfig.repeatGuide && currentWidth >= 1024 && (
            <>
              {!siderState ? (
                <Tooltip
                  title={t('sideBar.repeatGuide')}
                  placement="right"
                  overlayClassName={`sider__nav-tooltip_${siderState}`}
                >
                  <div className="side-bar__nav-link">
                    <div
                      className={`side-bar__link side-bar__link-${identity} side-bar__guide`}
                      onClick={() => setShowAppTour(true)}
                    >
                      <RepeatGuideSVG />
                      <span>{t('sideBar.repeatGuide')}</span>
                    </div>
                  </div>
                </Tooltip>
              ) : (
                <div className="side-bar__nav-link">
                  <div
                    className={`side-bar__link side-bar__link-${identity} side-bar__guide`}
                    onClick={() => setShowAppTour(true)}
                  >
                    <RepeatGuideSVG />
                    <span>{t('sideBar.repeatGuide')}</span>
                  </div>
                </div>
              )}
            </>
          )}*/}

          {/* {AppConfig.preOrderCard &&
          siderState ? (
            <div className={cn('side-bar__card-preorder', { es: i18n.language === 'es' })}>
              <a
                href={
                  token
                    ? `${process.env.REACT_APP_DEMO_CARD_API_URL}?token=${token}&lang=${
                        i18n.language !== 'en' ? i18n.language : undefined
                      }`
                    : `${process.env.REACT_APP_DEMO_CARD_API_URL}`
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button type="secondary">{t('sideBar.debitCard')}</Button>
              </a>
            </div>
          ) : (
            <div className="side-bar__card-preorder_icon">
              <a
                href={
                  token
                    ? `${process.env.REACT_APP_DEMO_CARD_API_URL}?token=${token}&lang=${
                        i18n.language !== 'en' ? i18n.language : undefined
                      }`
                    : `${process.env.REACT_APP_DEMO_CARD_API_URL}`
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                <CpayCardSVG />
              </a>
            </div>
          )} */}

          <div className="side-bar__controls">
            {currentWidth < 1024 ? <MerchantSelector /> : null}
            <HeaderUser />
          </div>
        </div>
      </div>
      <div className={`side-bar__bottom-block side-bar__bottom-block-${identity}`}>
        {AppConfig.identity === 'cpay' && (
          <div className="side-bar__nav-link">
            <a className={`side-bar__link side-bar__link-${identity}`} href={!AppConfig?.hideLogo ? "https://docs.gemewallet.com" : "https://docs.payblock.tech"} target="_blank" rel="noopener noreferrer">
              {' '}
              <DocumentaionSVGClarnium />
              <span>API Doc</span>
            </a>
          </div>
        )}
        {AppConfig.identity === 'nfg' && (
          <div className="side-bar__nav-link">
            <a className="side-bar__link" href="https://docs.crypto-now.io" target="_blank" rel="noopener noreferrer">
              {' '}
              <DocumentaionSVG />
              <span>{t('admin.documentation')}</span>
            </a>
          </div>
        )}
        {AppConfig.identity === 'finvaro' && (
          <div className="side-bar__nav-link">
            <a className="side-bar__link" href="https://docs.finvaro.com" target="_blank" rel="noopener noreferrer">
              {' '}
              <DocumentaionSVGFinvaro />
              <span>{t('admin.documentation')}</span>
            </a>
          </div>
        )}
        {AppConfig.identity === 'clarnium' && (
          <div className="side-bar__nav-link">
            <a className={`side-bar__link side-bar__link-${identity}`} href="https://docs.clarnium.io" target="_blank" rel="noopener noreferrer">
              {' '}
              <DocumentaionSVGClarnium />
              <span>{t('admin.documentation')}</span>
            </a>
          </div>
        )}
        {AppConfig.identity === 'inex' && (
          <div className="side-bar__nav-link">
            <a className={`side-bar__link side-bar__link-${identity}`} href="https://docs.inexlatampay.com/" target="_blank" rel="noopener noreferrer">
              {' '}
              <DocumentaionSVGClarnium />
              <span>{t('admin.documentation')}</span>
            </a>
          </div>
        )}
        {AppConfig.identity === 'insta' && (
          <div className="side-bar__nav-link">
            <a className={`side-bar__link side-bar__link-${identity}`} href="https://docs.instaxgateway.com/" target="_blank" rel="noopener noreferrer">
              {' '}
              <DocumentaionSVG />
              <span>{t('admin.documentation')}</span>
            </a>
          </div>
        )}
        {AppConfig.identity === 'coinera' && (
          <div className="side-bar__nav-link">
            <a className={`side-bar__link side-bar__link-${identity}`} href="https://docs-coin.finera.com/" target="_blank" rel="noopener noreferrer">
              {' '}
              <DocumentaionSVG />
              <span>{t('admin.documentation')}</span>
            </a>
          </div>
        )}
        {identity !== 'finvaro' && !AppConfig?.hideLogo && (
          <div className={`side-bar__nav-link ${identity === 'insta' && 'side-bar__nav-link-left'}`}>
            <a className={`side-bar__link ${(identity === 'insta' || identity === 'coinera') && 'side-bar__link--left'} side-bar__link-${identity} ${identity === 'nfg' && siderState && 'side-bar__link--padding'}`} href={`mailto:${linkForDocs[identity]}`}>
              <SupportSVG />
              <span>{linkForDocs[identity]}</span>
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  userRole: state.user.data.roles,
  userData: state.user.data,
  merchantId: state.transactions.merchantId,
  merchantData: state.merchantData.data,
});

const mapDispatchToProps = dispatch => ({
  getMerchantData: getMerchantData(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sider);